import {createMemoryHistory, createRouter} from 'vue-router';
import products_without_groups from "../components/rest/stop_list/products/ProductsWithoutGroups.vue";
import rest_stop_list from "../components/rest/stop_list/RestStopList.vue";
import locations_stop_list from "../components/rest/stop_list/locations/LocationsStopList.vue";
import products_select_stop_list from "../components/rest/stop_list/products/ProductsSelectStopList.vue";
import fast_stop_list from "../components/rest/stop_list/products/FastStopList.vue";


const routes = [
    {
        path: '/rest',
        name: 'RestStopList',
        component: rest_stop_list,
        props: true,
    },
    {
        path: '/products/:restId/:backState',
        name: 'ProductsStopList',
        component: products_select_stop_list,
        props: true,
    },
    {
        path: '/fast_stop_list/:backState',
        name: 'FastStopList',
        component: fast_stop_list,
        props: true,
    },
    {
        path: '/fast_stop_list/locations',
        name: 'FastStopListLocations',
        component: locations_stop_list,
        props: true,
    },
    {
        path: '/products_without_groups',
        name: 'ProductsWithoutGroups',
        component: products_without_groups,
        props: true,
    },
    {
        path: '/locations/:restId',
        name: 'LocationsStopList',
        component: locations_stop_list,
        props: true,
    },
    {
        path: '',
        redirect: '/rest'
    }

    // {
    //     path: '/:pathMatch(.*)*',
    //     redirect: '/rest'
    // },
]

const stop_list_router = createRouter({
    history: createMemoryHistory(),
    base: '/:lang/location/stop_list',
    routes
});

export default stop_list_router;

